import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { AppState, RootState } from '../types/store';
import { getExportById, ExportFile } from '../data-service';

// Mutations
const SET_EXPORT = 'setExport';

// Actions
const GET_EXPORT_BY_ID = 'getExportById';

// Getters
const EXPORT = 'export';
const EXPORT_FILES = 'exportFiles';

const state: AppState = {
  export: null
};

const mutations: MutationTree<AppState> = {
  [SET_EXPORT](state, exportResult) {
    state.export = exportResult;
  }
};

const actions: ActionTree<AppState, RootState> = {
  [GET_EXPORT_BY_ID]({ commit }, id: string) {
    return getExportById(id)
      .then(result => {
        commit(SET_EXPORT, result);
        return Promise.resolve(result);
      })
      .catch(error => Promise.reject(error));
  }
};

const getters: GetterTree<AppState, RootState> = {
  [EXPORT]: state => state.export,
  [EXPORT_FILES]: state => {
    if (state.export) {
      return state.export.exportFiles;
    }
  }
};

const appModule: Module<AppState, RootState> = {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
};

export default appModule;

export { GET_EXPORT_BY_ID, EXPORT_FILES, ExportFile };
